import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard'; // Import your AuthGuard
import { UnsavedChangesGuard } from './_guards/unsaved-changes.guard';
import { EditSessionSoftLockGuard } from './_guards/edit-session-soft-lock.guard';

import { LoginComponent } from './_components/login/login.component';
import { RegisterComponent } from './_components/register/register.component';
import { HomeComponent } from './_components/home/home.component';
//import { Home2Component } from './_components/home2/home2.component';
import { NoteViewComponent } from './_components/note/note-view.component';
import { NoteEditComponent } from './_components/note/note-edit.component';
import { ViewConflictComponent } from './_components/view-conflict/view-conflict.component';
import { PageNotFoundComponent } from './_components/page-not-found/page-not-found.component'; // adjust the path as necessary
import { ErrorComponent } from './_components/error/error.component';
import { ManageComponent } from './_components/manage/manage.component';
import { UserSettingsComponent } from './_components/user-settings/user-settings.component';
// import { ListComponent } from './_components/list/list.component';
import { SyncListComponent } from './_components/sync-list/sync-list.component';
import { TrashComponent } from './_components/trash/trash.component';
// import { PrintItemComponent } from './_components/print-item/print-item.component';
import { EditTagsComponent } from './_components/edit-tags/edit-tags.component';
import { ManageAttachmentsComponent } from './_components/manage-attachments/manage-attachments.component';
import { SpaceAdminComponent } from './_components/space-admin/space-admin.component';
import { ManageSpacesComponent } from './_components/manage-spaces/manage-spaces.component';
import { PrimeUiDemoComponent } from './_components/debug/prime-ui-demo/prime-ui-demo.component';
import { AI_DEBUG_ROUTES } from './ai-debug/ai-debug.routes';
import { NotesappErrorReportComponent } from './reports/notesapp-error-report/notesapp-error-report.component';
import { AiRequestsLogReportComponent } from './reports/ai-requests-log-report/ai-requests-log-report.component';
import { AiLimitsReportComponent } from './reports/ai-limits-report/ai-limits-report.component';

export const routes: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },   // CHANGE TO login!!
    { path: 'login', component: LoginComponent },
    { path: 'register', component: RegisterComponent },
    { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
    // { path: 'home2', component: Home2Component, canActivate: [AuthGuard] },
    // The note View and Edit pages.
    { path: 'view/:_id', component: NoteViewComponent, canActivate: [AuthGuard] },
    {
        path: 'edit/:_id',
        component: NoteEditComponent,
        canDeactivate: [UnsavedChangesGuard],
        canActivate: [AuthGuard, EditSessionSoftLockGuard],
    },
    // Older URLs for the same pages (bookmarks, links inside notes, saved edit sessions).
    { path: 'view2/:_id', redirectTo: 'view/:_id', pathMatch: 'full' },
    { path: 'view-workspace/:_id', redirectTo: 'view/:_id' },
    { path: 'edit-workspace/:_id', redirectTo: 'edit/:_id' },
    { path: 'view-conflict', component: ViewConflictComponent, canActivate: [AuthGuard] },
    { path: 'manage', component: ManageComponent, canActivate: [AuthGuard]  },
    { path: 'user-settings', component: UserSettingsComponent, canActivate: [AuthGuard]  },
        { path: 'edit-tags', component: EditTagsComponent, canActivate: [AuthGuard]  },
    { path: 'manage-attachments', component: ManageAttachmentsComponent, canActivate: [AuthGuard] },
    { path: 'manage-spaces', component: ManageSpacesComponent, canActivate: [AuthGuard] },
    { path: 'space-admin/:spaceId', component: SpaceAdminComponent, canActivate: [AuthGuard] },
    // { path: 'print-item', component: PrintItemComponent, canActivate: [AuthGuard]  },
    { path: 'sync-list', component: SyncListComponent, canActivate: [AuthGuard]  },
    { path: 'trash', component: TrashComponent, canActivate: [AuthGuard] },
    // { path: 'list', component: ListComponent, canActivate: [AuthGuard]  },
    { path: 'prime-ui-demo', component: PrimeUiDemoComponent },
    { path: 'reports/notesapp-errors', component: NotesappErrorReportComponent, canActivate: [AuthGuard] },
    { path: 'reports/ai-requests-log', component: AiRequestsLogReportComponent, canActivate: [AuthGuard] },
    { path: 'reports/ai-limits', component: AiLimitsReportComponent, canActivate: [AuthGuard] },
    ...AI_DEBUG_ROUTES.map(route => (route.redirectTo ? route : { ...route, canActivate: [AuthGuard] })),
    { path: 'error', component: PageNotFoundComponent },
    { path: '**', component: ErrorComponent },
];

// export const routes: Routes = [];


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
